<template>
    <div class="areamanager">
      <div style="margin-bottom: 20px">
        <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
        <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
      </div>
      <div style="border: 1px solid #c9cdd6">
        <el-table
            :header-cell-style="{background:'#F5F5F5'}"
            :data="tableData"
            max-height="600"
            style="width: 100%"
        >
          <el-table-column
              prop="proviceName"
              label="区域">
          </el-table-column>
          <el-table-column
              prop="workerName"
              label="负责人">
          </el-table-column>
          <el-table-column
              fixed="right"
              width="150"
              align="center"
              label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
              <!--            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
          :title="modelTitle"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          width="450px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px"  class="demo-ruleForm">
          <el-form-item label="区域(省)" prop="proviceName">
            <el-select v-model="ruleForm.provinceID" placeholder="请选择"  @change="changeValue($event,'proviceID')">
    <el-option
      v-for="item in proviceNames"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
          </el-form-item>
          <el-form-item label="区域售后负责人" prop="workerName">
            <el-select   v-model="ruleForm.workerID" placeholder="请选择" @change="changeValue($event,'workerID')">
    <el-option
      v-for="item in workerNames"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
import { Select } from 'element-ui';  
  export default {
    data() {
      let _that=this
      return {
        isShowInfo:false,
        tableData: [],
        proviceNames:[],
        workerNames:[],
        modelTitle: '新增售后区域负责人',
        dialogVisible: false,
        ruleForm: {
            proviceName: "",
            workerName: "",
            workerID:undefined,
            provinceID:undefined
        },
        rules: {
            proviceName: [
            {required: true, message: '请选择区域', trigger: 'blur'},
          ],
          workerName: [
            {required: true, message: '请选择区域负责人', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      changeValue(id, name) { // 字典
        if (name === 'proviceID') {
          var provice=this.proviceNames.filter(function (provice) {
                    return provice.id == id;
                })
          this.ruleForm.proviceName = provice[0].name
          this.ruleForm.provinceID = provice[0].id
        } else {
          var worker=this.workerNames.filter(function (worker) {
                    return worker.id == id;
                })
          this.ruleForm.workerName = worker[0].name
          this.ruleForm.workerID = worker[0].id
        }
      
    },
      search() {
        this.init()
      },
      addItem() {
        this.modelTitle = '新增售后区域负责人'
        this.ruleForm = {
            proviceName: "",
            workerName: "",
            workerID:undefined,
            provinceID:undefined
        },
        this.dialogVisible = true
      },
      editorClick(row) {
        this.modelTitle = '编辑售后区域负责人'
        this.ruleForm = {
          id:row.id,
          provinceID:row.provinceID,
          proviceName: row.proviceName,
          workerID: row.workerID,
          workerName:row.workerName
        }
        this.dialogVisible = true
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = {
              ...this.ruleForm,
            }
            if (this.modelTitle === '编辑售后区域负责人') {
              this.axios
                  .put("api/AreaManager", data).then((res) => {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                },);
                this.$refs[formName].resetFields();
                this.dialogVisible=false;
                this.init();
              })
            } else {
              this.axios
                    .post("api/AreaManager", data).then((res) => {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.$refs[formName].resetFields();
                this.dialogVisible=false;
                this.init();
                
              })
            }
          } else {
            return false;
          }
        });
      },
      init() {
        this.axios
            .get("api/AreaManager/all")
            .then((res) => {
              this.tableData = res;
            }),
            this.axios
            .get("api/Area/GetTreeNode?code=China")
            .then((res) => {
              this.proviceNames = res;
            }),
            this.axios
            .get("api/Worker?roleId=29&page=1&pageSize=100")
            .then((res) => {
              this.workerNames = res.list;
            })
      },
      
    },
    mounted() {
    this.init()
  }


  }
  </script>
  
  <style lang="scss" scoped>
   .areamanager {
  }
  </style>